export const BUTTON_MIN_WIDTH = '104px'
